import { useState } from "react";
import { X } from "lucide-react";
import { BANNER } from "@/constants/testIds";

export const DemoBanner = () => {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem("eipi_demo_banner_dismissed") === "1"
  );
  if (dismissed) return null;
  return (
    <div
      data-testid={BANNER.demoBanner}
      className="w-full bg-[#181818] border-b border-[#2A2A2A] text-[#CCFF00] font-mono text-[10px] sm:text-xs uppercase tracking-widest px-3 sm:px-6 py-2 flex items-center justify-between gap-3"
    >
      <span className="truncate">Design preview — sample projects use licensed stock footage, not real EiPi client work</span>
      <button
        type="button"
        aria-label="Dismiss notice"
        data-testid={BANNER.dismiss}
        onClick={() => {
          localStorage.setItem("eipi_demo_banner_dismissed", "1");
          setDismissed(true);
        }}
        className="shrink-0 text-[#888880] hover:text-[#F5F5F0] min-w-[28px] min-h-[28px] flex items-center justify-center transition-colors"
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default DemoBanner;
